import { toast } from "sonner";
import { Copy, Check } from "lucide-react";
import React, { useState } from "react";

/**
 * Show a one-time plaintext password toast with copy-to-clipboard.
 * The password is intentionally gone after the toast is dismissed.
 */
function PasswordToastBody({ label, password }) {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(password);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // Fallback: select the text manually
    }
  };
  return (
    <div className="flex flex-col gap-2" data-testid="password-toast">
      <div className="text-sm font-semibold text-slate-900">{label}</div>
      <div className="text-[11px] text-slate-500">
        Shown once — copy it now and share securely. Closing this toast clears it.
      </div>
      <div className="flex items-center gap-2 rounded-md border border-slate-200 bg-slate-50 px-2 py-1.5">
        <code
          className="flex-1 truncate font-mono text-sm text-slate-900"
          data-testid="password-toast-value"
        >
          {password}
        </code>
        <button
          type="button"
          onClick={copy}
          data-testid="password-toast-copy"
          className="inline-flex items-center gap-1 rounded-md border border-slate-200 bg-white px-2 py-1 text-xs font-medium text-slate-600 hover:bg-slate-100"
        >
          {copied ? <Check className="h-3 w-3 text-cargodash-primary-600" /> : <Copy className="h-3 w-3" />}
          {copied ? "Copied" : "Copy"}
        </button>
      </div>
    </div>
  );
}

export function showPasswordToast({ label, password }) {
  toast.custom(
    (t) => <PasswordToastBody label={label} password={password} />,
    { duration: 60000, className: "!w-[360px]" }
  );
}
